import { getEntries, groupReplacements, typographyReplacements } from './createCssVars';
import { safeLocalStorageGet } from './getLocalThemeSettings';
export const LOCAL_STORAGE_DANGEROUSLY_USE_CSS_VARIABLES_KEY = 'trellis:local-dev-only-use-css-variables';
export function getUseCssVariables() {
  const useCssVariables = safeLocalStorageGet(LOCAL_STORAGE_DANGEROUSLY_USE_CSS_VARIABLES_KEY);
  return useCssVariables === 'true';
}

/**
 * Returns a version of baseTheme that uses CSS variables for all values.
 * This is only intended for use in local development.
 * @param baseTheme
 * @returns
 */
export const getCssVariablesTheme = baseTheme => {
  const cssVarsTheme = {
    color: {},
    space: {},
    borderRadius: {},
    borderWidth: {},
    boxShadow: {},
    typography: {}
  };
  for (const [group, values] of getEntries(baseTheme)) {
    if (group === 'typography') {
      const currentTypographyGroup = cssVarsTheme.typography;
      for (const [varName, typographyValues] of getEntries(values)) {
        var _currentTypographyGro;
        const currentStyleObject = (_currentTypographyGro = currentTypographyGroup[varName]) !== null && _currentTypographyGro !== void 0 ? _currentTypographyGro : currentTypographyGroup[varName] = {};
        for (const [key] of getEntries(typographyValues)) {
          const replacementKey = typographyReplacements[key];
          const cssVariableName = `var(--trellis-${group}-${varName}-${replacementKey}, ${typographyValues[key]})`;
          currentStyleObject[key] = cssVariableName;
        }
      }
    } else {
      const groupName = groupReplacements[group] || group;
      const currentGroup = cssVarsTheme[group];
      for (const [varName] of Object.entries(values)) {
        const cssVariableName = `var(--trellis-${groupName}-${varName}, ${values[varName]})`;
        currentGroup[varName] = cssVariableName;
      }
    }
  }
  return Object.assign({}, cssVarsTheme, {
    theme: baseTheme
  });
};